module.exports = __webpack_public_path__ + "img/2-gagner-pimentos.1e8e24a6.png";